<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit, invalid, validate }"
    slim
  >
    <form
      class="gl-modal__form"
      @reset.prevent="onCancel"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <div
        class="form-content-wrapper"
        :class="[{ 'form-content-wrapper__overflowing' : overflowingForm }]"
        :style="[{ 'max-height': `${maxHeight}` }]"
      >
        <slot :validate="validate" />
      </div>
      <div :class="['gl-form__actions', {'gl-form__actions--centered': okOnly}, {'gl-form__actions--end': toEnd} ]">
        <div
          v-if="$slots['actions-prefix']"
          class="gl-form__actions-prefix"
        >
          <slot name="actions-prefix" />
        </div>
        <button
          v-if="!okOnly"
          class="gl-button gl-button--light gl-form__button gl-form__button-form gl-form__cancel-button gl-button--padder mr-2"
          :class="{ 'full-submit': fullButtons, 'mr-3': fullButtons }"
          :disabled="loading"
          type="reset"
        >
          {{ cancelTitle }}
        </button>
        <button
          class="gl-button gl-button--dark gl-form__button gl-form__button-form gl-form__submit-button gl-button--padder"
          :class="[{ 'full-submit': fullSubmit || fullButtons }, { 'gl-form__submit-button--critical': criticalSubmit }]"
          :disabled="sideValid || loading || disabledSubmit || invalid"
          type="submit"
        >
          {{ submitTitle }}
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'GlForm',
  components: {
    ValidationObserver,
  },
  props: {
    cancelTitle: {
      type: String,
      default: 'Cancel',
    },
    submitTitle: {
      type: String,
      default: 'Submit',
    },
    loading: {
      type: Boolean,
      default: false
    },
    okOnly: {
      type: Boolean,
      default: false
    },
    sideValid: {
      type: Boolean,
      default: false
    },
    fullButtons: {
      type: Boolean,
      default: false,
    },
    fullSubmit: {
      type: Boolean,
      default: false
    },
    overflowingForm: {
      type: Boolean,
      default: false
    },
    toEnd: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: String,
      default: '50vh',
    },
    disabledSubmit: {
      type: Boolean,
      default: false,
    },
    criticalSubmit: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    setErrors(errors) {
      this.$refs.form.setErrors(errors)
    },
    onSubmit() {
      this.$emit('submit')
    },
    onCancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style>
.gl-modal__form .gl-button {
  font-size: 14px;
  text-transform: capitalize;
}

.gl-form__actions-prefix {
  margin-right: auto;
}
</style>
